import React from "react"

import {Sidebar, SidebarItem} from "../../shared"
import Console from "./Console"
import ShoppingList from "../Catalogue/ShoppingList"


function CheckoutSidebar(props) {
  return (
    <Sidebar className="checkout">
      <SidebarItem title="Dein Warenkorb">
        <ShoppingList showCheckoutLink={false} />
      </SidebarItem>
      <SidebarItem >
        <Console stepName={props.stepName} showExplanation={true} showValidation={false} onClickNext={props.onClickNext} />
      </SidebarItem>
    </Sidebar>
  )
}

export default CheckoutSidebar